import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QuotationCloseReasonModel } from './quotationCloseReason.model';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs';

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root'
})
export class QuotationCloseReasonService {

  constructor(private http: HttpClient) {}

  addQuotationCloseReason(quotationclosereason: QuotationCloseReasonModel) {
    
    return this.http.post(API_URL + '/QuotationCloseReason/CreateQuotationCloseReason', quotationclosereason, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateQuotationCloseReason(quotationclosereason: QuotationCloseReasonModel) {
    
    return this.http.put(API_URL + '/QuotationCloseReason/UpdateQuotationCloseReason', quotationclosereason, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllQuotationCloseReasons() {
    return this.http.get(API_URL + '/QuotationCloseReason/ReadQuotationCloseReasons', {
      withCredentials: true,
    }).pipe(
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


  deleteQuotationCloseReason(quotationclosereason: QuotationCloseReasonModel) {
    
    return this.http.delete(API_URL + '/QuotationCloseReason/DeleteQuotationCloseReason',  {
      headers: {},
      body: quotationclosereason,
      withCredentials: true
   }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }
}
